import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { EventsService, FundraiserService, UtilService, VariablesService } from 'src/app/shared/services';
import { PaymentUtilService } from 'src/app/common/payment/services';
import { MatButtonModule } from '@angular/material/button';
import { MatRippleModule } from '@angular/material/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { ProgressBarModule } from 'src/app/common/progress-bar/progress-bar.module';
import { MatDialog } from '@angular/material/dialog';
import { Bulk_Min_Amount } from 'src/app/shared/models/bulk-min-amount';

@Component({
  selector: 'app-bulk-donation-selection-v2',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatRippleModule, SharedModule, ProgressBarModule],
  templateUrl: './bulk-donation-selection-v2.component.html',
  styleUrls: ['./bulk-donation-selection-v2.component.scss']
})
export class BulkDonationSelectionV2Component {

  @Input() amount;
  @Input() currency;
  @Input() campaign_id;
  @Input() disabled;
  @Input() isOrderLoading;
  @Output() onSubmit = new EventEmitter();

  @ViewChild('bulkDonation', { static: true }) bulkDonation;

  bulkData = {};
  minamt = 0;
  selected = [];
  totalamt;
  campaigns: any[];
  btnlabel;
  isAnySelected = false;
  bulkMinAmount = Bulk_Min_Amount;
  isMobile;

  constructor(
    private bottomSheet: MatBottomSheet,
    private dialog: MatDialog,
    private events: EventsService,
    private fundraiserService: FundraiserService,
    private paymentUtil: PaymentUtilService,
    public util: UtilService,
    public vars: VariablesService
  ) { }

  ngOnInit() {
    this.isMobile = this.util.isMobile();
  }

  getCampaigns(currency) {
    const qpram = `?campaignId=${this.vars?.fundraiser?.id}&causeId=${this.vars?.fundraiser?.cause_id}&limit=3&tags=featured&with=beneficiaryname;storyWidget&orderBy=priority_entity&sortBy=ASC&currency=` + currency;
    this.fundraiserService.getUrgentStoryCampaigns(qpram).subscribe((res: any) => {
      const camp_list: any[] = res.data.data;
      this.campaigns = camp_list.filter(item => this.campaign_id !== item?.id).filter((item, i) => i < 2);
      this.campaigns = this.campaigns.map((val, i) => {
        if (val?.raised?.raised && val?.amount_requested) {
          val['amount_remaining'] = val?.amount_requested - val?.raised?.raised;
          if (val?.amount_remaining < 0) {
            val['amount_remaining'] = '0';
          }
        }
        return val;
      });
      this.setBtnLabel();
    });
  }

  openSheet(event?) {
    this.btnlabel = `Skip and Contribute ${this.util.formatAmount(this.amount, this.currency)}`;
    this.getCampaigns(this.currency);

    if (this.disabled) {
      this.onSubmit.emit(false);
      return false;
    }
    if (this.util.isMobile()) {
      this.bottomSheet.open(this.bulkDonation, {
        panelClass: 'bulk-sheet'
      });
    } else {
      this.dialog.open(this.bulkDonation, {
        width: '531px',
        panelClass: 'bulk-dialog'
      });
    }
    if (event) {
      event.preventDefault();
    }
  }

  hide(id) {
    this.selected.push(id);
    this.bulkData[id] = { amount: this.minamt };
    if (this.bulkData[id].amount === 0) {
      this.bulkData[id].amount = this.bulkData[id].amount + this.bulkMinAmount[this.currency].minamt;
    }
    this.setBtnLabel();
    this.events.sendSystemEvent({
      eventName: 'amountinc',
    }).subscribe(_ => _);
  }

  amtchanger(value, id) {
    if (value === 'plus' && this.bulkData[id]?.amount < this.bulkMinAmount[this.currency]?.minamt * 20) {
      this.bulkData[id].amount = this.bulkData[id].amount + this.bulkMinAmount[this.currency].incramt;
    }
    if (value === 'minus') {
      if (this.bulkData[id].amount > this.bulkMinAmount[this.currency].minamt) {
        this.bulkData[id].amount = this.bulkData[id].amount - this.bulkMinAmount[this.currency].incramt;
      } else {
        this.events.sendSystemEvent({
          eventName: 'amountdec',
        }).subscribe(_ => _);
        this.selected.splice(this.selected.indexOf(id), 1);
        this.bulkData[id].amount = 0;
        delete this.bulkData[id];
      }
    }
    this.setBtnLabel();
  }

  setBtnLabel() {
    this.totalamt = Object.values(this.bulkData).reduce((a, { amount }) => a + amount, 0);
    if (this.totalamt > 0) {
      this.isAnySelected = true;
      this.btnlabel = `Contribute ${this.util.formatAmount(this.amount + this.totalamt, this.currency)}`;
    } else {
      this.isAnySelected = false;
      this.btnlabel = `Skip and Contribute ${this.util.formatAmount(this.amount, this.currency)}`;
    }
  }

  close() {
    if (this.util.isMobile()) {
      this.bottomSheet.dismiss(this.bulkDonation);
    } else {
      this.dialog.closeAll();
    }
  }

  submit() {
    if (Object.keys(this.bulkData).length === 0) {
      this.onSubmit.emit(false);
    } else {
      this.onSubmit.emit(this.bulkData);
    }
    this.paymentUtil?.cartResponse.subscribe((res) => {
      if (res) {
        if (this.util.isMobile()) {
          this.bottomSheet.dismiss(this.bulkDonation);
        } else {
          this.dialog.closeAll();
        }
      }
    });
  }

}